import type { ApplicationResponseStatus } from 'generatedTypes/flight/models';

import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('applicationsGridRow');

    return {
        APPLICATION_STATUS: (status: ApplicationResponseStatus) => {
            const statusKey = status.toLowerCase();

            return t(statusKey);
        }
    };
};

export default useTranslation;
